// extracted by mini-css-extract-plugin
export var defaultFont = "index-module--default-font--RjqQS";
export var fontWeight500 = "index-module--font-weight-500--VVtpS";
export var codeFont = "index-module--code-font--wA3Ah";
export var textGreen = "index-module--text-green--loe4a";
export var clearButtonStyles = "index-module--clear-button-styles--cDY66";
export var wrapper = "index-module--wrapper--i0rTB";
export var show_mobile_menu = "index-module--show_mobile_menu--ME7o6";